/** capps: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "dropZone": "Drag your app's .zip here",
  "dropNow": "Drop to add it",
  "orBrowse": "or click to choose a file",
  "notZip": "That isn't a .zip file. Zip the app folder and try again.",
  "checking": "checking…",
  "replace": "Replace",
  "remove": "Remove",
  "appCreated": "Created “{name}”",
  "publish": "Publish",
  "publishAgain": "Publish again",
  "viewInContent": "View in Content",
  "saveAndAnother": "Save & create another",
  "madeHere": "Created here: {n} app | Created here: {n} apps",
  "publishAll": "Publish all {n}",
  "publishedBadge": "Published",
  "clearList": "Clear list",
  "savedOf": "Saved the attributes of {name}",
  "added": "Added “{name}”",
  "zipLimits": "Put index.html at the top of the zip. Up to {mb} MB and {files} files.",
  "nFiles": "{n} file | {n} files",
  "unpacked": "{files} · {size} unpacked",
  "nSettings": "{n} setting | {n} settings",
  "nFeeds": "{n} data feed | {n} data feeds",
  "mayCall": "may call {list}",
  "makeCurrentQ": "Make version {v} current? The {n} content item using this app switches to it, and its players update. | Make version {v} current? The {n} content items using this app switch to it, and their players update.",
  "nowCurrent": "Version {v} is now current",
  "uploadedCurrent": "Version {v} uploaded and now current",
  "deleteQ": "Delete “{name}” and all its versions?",
  "deletedX": "Deleted “{name}”",
  "headline": "Custom app · version {v} · used by {n} content item | Custom app · version {v} · used by {n} content items",
  "olderPlayers": "{n} player runs an older player version that can’t show custom apps ({names}). They skip the app until they’re updated. | {n} players run an older player version that can’t show custom apps ({names}). They skip the app until they’re updated.",
  "sizeFiles": "{size} · {n} files",
  "requiredSuffix": " · required",
  "mayCallLong": "May call {list}. Everything else is blocked on players.",
  "becomesCurrent": "It becomes current, and the players using “{name}” update.",
  "zipTop": "index.html at the top, up to {mb} MB.",
  "noLonger": "This version no longer declares: {list}. Values set for them are no longer used.",
  "attrsSaved": "Attributes saved",
  "saveAttrs": "Save attributes",
  "saving": "Saving…",
  "cancel": "Cancel",
  "requiredSr": "(required)",
  "separate": "Separate values with commas",
  "title": "Apps",
  "intro": "Built-in apps, and your own HTML5 apps. Add an app to your content from here or from Content → New App.",
  "newCustom": "New custom app",
  "systemApps": "System apps",
  "myApps": "My apps",
  "searchApps": "Search apps",
  "install": "+ Install",
  "noAppMatch": "No app matches.",
  "retry": "Retry",
  "colApp": "App",
  "colVersion": "Version",
  "colUsedBy": "Used by",
  "colStatus": "Status",
  "colUpdated": "Updated",
  "ready": "Ready",
  "loading": "Loading…",
  "noAppsMatch": "No apps match.",
  "noCustom": "No custom apps yet",
  "emptyHint": "Upload your own HTML5 app as a .zip. It plays offline on your players, in any section of a campaign.",
  "starter": "Download the starter template",
  "uploadDesc": "Upload an HTML5 app as a .zip, with index.html at the top.",
  "howTo": "How to build a Displaro app",
  "manifestNote": "An optional manifest.json declares settings, Data Feeds and the https addresses the app may call.",
  "codotJs": "Include codot.js to receive settings and feed data. The app runs offline on the player.",
  "zip": "App (.zip)",
  "name": "Name",
  "optional": "(optional)",
  "notes": "Notes",
  "notesPh": "What this version contains",
  "noNetwork": "no network access",
  "uploading": "Uploading…",
  "addApp": "Add app",
  "saved": "Saved",
  "sText": "Text",
  "sNumber": "Number",
  "sBool": "On / off",
  "sColor": "Colour",
  "sChoice": "Choice",
  "myAppsCrumb": "/ My apps",
  "uploadNew": "Upload new version",
  "deleteFirst": "Delete the content items using it first",
  "delete": "Delete",
  "details": "Details",
  "description": "Description",
  "save": "Save",
  "versions": "Versions",
  "colUploaded": "Uploaded",
  "colSize": "Size",
  "actions": "Actions",
  "current": "Current",
  "makeCurrent": "Make current",
  "switching": "Switching…",
  "declares": "What the app declares",
  "settings": "Settings",
  "none": "None",
  "dataFeeds": "Data feeds",
  "network": "Network",
  "noNetworkLong": "No network access: the app uses only its own files and data feeds.",
  "notUsed": "Not used yet. Add it from Content → New App.",
  "preview": "Preview",
  "defaultSettings": "· default settings",
  "whatChanged": "What changed",
  "upload": "Upload"
};
const ar: typeof en = {
  "dropZone": "اسحب ملف ‎.zip‎ الخاص بالتطبيق إلى هنا",
  "dropNow": "أفلته لإضافته",
  "orBrowse": "أو انقر لاختيار ملف",
  "notZip": "هذا ليس ملف ‎.zip‎. اضغط مجلد التطبيق وحاول مجددًا.",
  "checking": "جارٍ الفحص…",
  "replace": "استبدال",
  "remove": "إزالة",
  "appCreated": "تم إنشاء «{name}»",
  "publish": "نشر",
  "publishAgain": "نشر مجددًا",
  "viewInContent": "عرض في المحتوى",
  "saveAndAnother": "حفظ وإنشاء آخر",
  "madeHere": "أُنشئ هنا: لا تطبيقات | أُنشئ هنا: تطبيق واحد | أُنشئ هنا: تطبيقان | أُنشئ هنا: {n} تطبيقات | أُنشئ هنا: {n} تطبيقًا | أُنشئ هنا: {n} تطبيق",
  "publishAll": "نشر الكل ({n})",
  "publishedBadge": "منشور",
  "clearList": "مسح القائمة",
  "savedOf": "تم حفظ سمات {name}",
  "added": "تمت إضافة «{name}»",
  "zipLimits": "ضع index.html في المستوى الأعلى من الملف المضغوط. حتى {mb} ميغابايت و{files} ملف.",
  "nFiles": "لا ملفات | ملف واحد | ملفان | {n} ملفات | {n} ملفًا | {n} ملف",
  "unpacked": "{files} · {size} بعد فك الضغط",
  "nSettings": "لا إعدادات | إعداد واحد | إعدادان | {n} إعدادات | {n} إعدادًا | {n} إعداد",
  "nFeeds": "لا مصادر بيانات | مصدر بيانات واحد | مصدرا بيانات | {n} مصادر بيانات | {n} مصدر بيانات | {n} مصدر بيانات",
  "mayCall": "قد يستدعي {list}",
  "makeCurrentQ": "جعل الإصدار {v} حاليًا؟ | جعل الإصدار {v} حاليًا؟ سينتقل إليه عنصر المحتوى الذي يستخدم هذا التطبيق، وتُحدَّث مشغلاته. | جعل الإصدار {v} حاليًا؟ سينتقل إليه عنصرا المحتوى اللذان يستخدمان هذا التطبيق، وتُحدَّث مشغلاتهما. | جعل الإصدار {v} حاليًا؟ ستنتقل إليه {n} عناصر محتوى تستخدم هذا التطبيق، وتُحدَّث مشغلاتها. | جعل الإصدار {v} حاليًا؟ سينتقل إليه {n} عنصر محتوى يستخدم هذا التطبيق، وتُحدَّث مشغلاتها. | جعل الإصدار {v} حاليًا؟ سينتقل إليه {n} عنصر محتوى يستخدم هذا التطبيق، وتُحدَّث مشغلاتها.",
  "nowCurrent": "الإصدار {v} هو الحالي الآن",
  "uploadedCurrent": "تم رفع الإصدار {v} وأصبح الحالي",
  "deleteQ": "حذف «{name}» وكل إصداراته؟",
  "deletedX": "تم حذف «{name}»",
  "headline": "تطبيق مخصص · الإصدار {v} · غير مستخدم | تطبيق مخصص · الإصدار {v} · مستخدم في عنصر محتوى واحد | تطبيق مخصص · الإصدار {v} · مستخدم في عنصرَي محتوى | تطبيق مخصص · الإصدار {v} · مستخدم في {n} عناصر محتوى | تطبيق مخصص · الإصدار {v} · مستخدم في {n} عنصر محتوى | تطبيق مخصص · الإصدار {v} · مستخدم في {n} عنصر محتوى",
  "olderPlayers": "لا مشغلات قديمة. | مشغل واحد يعمل بإصدار قديم لا يعرض التطبيقات المخصصة ({names}). يتخطى التطبيق حتى يُحدَّث. | مشغلان يعملان بإصدار قديم لا يعرض التطبيقات المخصصة ({names}). يتخطيان التطبيق حتى يُحدَّثا. | {n} مشغلات تعمل بإصدار قديم لا يعرض التطبيقات المخصصة ({names}). تتخطى التطبيق حتى تُحدَّث. | {n} مشغلًا يعمل بإصدار قديم لا يعرض التطبيقات المخصصة ({names}). تتخطى التطبيق حتى تُحدَّث. | {n} مشغل يعمل بإصدار قديم لا يعرض التطبيقات المخصصة ({names}). تتخطى التطبيق حتى تُحدَّث.",
  "sizeFiles": "{size} · {n} ملف",
  "requiredSuffix": " · مطلوب",
  "mayCallLong": "قد يستدعي {list}. وكل ما عداه محظور على المشغلات.",
  "becomesCurrent": "يصبح الحالي، وتُحدَّث المشغلات التي تستخدم «{name}».",
  "zipTop": "index.html في المستوى الأعلى، حتى {mb} ميغابايت.",
  "noLonger": "لم يعد هذا الإصدار يحدد: {list}. لم تعد القيم المضبوطة لها مستخدمة.",
  "attrsSaved": "تم حفظ السمات",
  "saveAttrs": "حفظ السمات",
  "saving": "جارٍ الحفظ…",
  "cancel": "إلغاء",
  "requiredSr": "(مطلوب)",
  "separate": "افصل القيم بفواصل",
  "title": "التطبيقات",
  "intro": "تطبيقات مدمجة، وتطبيقات HTML5 الخاصة بك. أضف تطبيقًا إلى محتواك من هنا أو من المحتوى ← تطبيق جديد.",
  "newCustom": "تطبيق مخصص جديد",
  "systemApps": "تطبيقات النظام",
  "myApps": "تطبيقاتي",
  "searchApps": "البحث في التطبيقات",
  "install": "+ تثبيت",
  "noAppMatch": "لا يوجد تطبيق مطابق.",
  "retry": "إعادة المحاولة",
  "colApp": "التطبيق",
  "colVersion": "الإصدار",
  "colUsedBy": "مستخدم في",
  "colStatus": "الحالة",
  "colUpdated": "آخر تحديث",
  "ready": "جاهز",
  "loading": "جارٍ التحميل…",
  "noAppsMatch": "لا توجد تطبيقات مطابقة.",
  "noCustom": "لا توجد تطبيقات مخصصة بعد",
  "emptyHint": "ارفع تطبيق HTML5 خاصًا بك كملف ‎.zip. يعمل دون اتصال على مشغلاتك، في أي قسم من الحملة.",
  "starter": "تنزيل القالب المبدئي",
  "uploadDesc": "ارفع تطبيق HTML5 كملف ‎.zip، مع index.html في المستوى الأعلى.",
  "howTo": "كيفية بناء تطبيق Displaro",
  "manifestNote": "يحدد ملف manifest.json الاختياري الإعدادات ومصادر البيانات وعناوين https التي قد يستدعيها التطبيق.",
  "codotJs": "ضمّن codot.js لتلقي الإعدادات وبيانات المصادر. يعمل التطبيق دون اتصال على المشغل.",
  "zip": "التطبيق (‎.zip)",
  "name": "الاسم",
  "optional": "(اختياري)",
  "notes": "ملاحظات",
  "notesPh": "ما يحتويه هذا الإصدار",
  "noNetwork": "بلا وصول للشبكة",
  "uploading": "جارٍ الرفع…",
  "addApp": "إضافة التطبيق",
  "saved": "تم الحفظ",
  "sText": "نص",
  "sNumber": "رقم",
  "sBool": "تشغيل / إيقاف",
  "sColor": "لون",
  "sChoice": "اختيار",
  "myAppsCrumb": "/ تطبيقاتي",
  "uploadNew": "رفع إصدار جديد",
  "deleteFirst": "احذف عناصر المحتوى التي تستخدمه أولًا",
  "delete": "حذف",
  "details": "التفاصيل",
  "description": "الوصف",
  "save": "حفظ",
  "versions": "الإصدارات",
  "colUploaded": "تاريخ الرفع",
  "colSize": "الحجم",
  "actions": "الإجراءات",
  "current": "الحالي",
  "makeCurrent": "جعله الحالي",
  "switching": "جارٍ التبديل…",
  "declares": "ما يحدده التطبيق",
  "settings": "الإعدادات",
  "none": "لا شيء",
  "dataFeeds": "مصادر البيانات",
  "network": "الشبكة",
  "noNetworkLong": "بلا وصول للشبكة: يستخدم التطبيق ملفاته ومصادر بياناته فقط.",
  "notUsed": "غير مستخدم بعد. أضفه من المحتوى ← تطبيق جديد.",
  "preview": "معاينة",
  "defaultSettings": "· الإعدادات الافتراضية",
  "whatChanged": "ما الذي تغيّر",
  "upload": "رفع"
};
export default { en, ar };
